(() => {
  // Sends shoppers back to the page and section they signed in from. Shopify's
  // storefront_login_url already returns to the page (path and query) but is built on the
  // server, so it can't know the #section (for example a My Tech tab). Add it on click, and
  // keep a copy in case Shopify drops the fragment on the way back.
  const KEY = "plug-signin-return-v1";
  const MAX_AGE = 30 * 60 * 1000;
  const here = () => location.pathname + location.search;
  const source = document.getElementById("plug-customer-session");
  let customer = "";
  try {
    customer = source ? String(JSON.parse(source.textContent) || "") : "";
  } catch {}

  if (customer) {
    let saved = null;
    try {
      saved = JSON.parse(sessionStorage.getItem(KEY) || "null");
      sessionStorage.removeItem(KEY);
    } catch {}
    if (
      saved &&
      !location.hash &&
      String(saved.path).split("?")[0] === location.pathname &&
      /^#[\w-]+$/.test(saved.hash || "") &&
      Date.now() - saved.at < MAX_AGE
    ) {
      history.replaceState(history.state, "", here() + saved.hash);
      window.dispatchEvent(new HashChangeEvent("hashchange"));
    }
  }

  document.addEventListener(
    "click",
    (event) => {
      const link = event.target.closest?.('a[href*="/customer_authentication/login"]');
      if (!link) return;
      const login = new URL(link.href, location.origin);
      if (login.origin !== location.origin) return;
      const [target, fragment] = (login.searchParams.get("return_to") || here()).split("#");
      // Only add a section to a return that lands on this same page; returns elsewhere
      // (order tracking ?order=, device owner anchors) are already complete.
      if (target.split("?")[0] !== location.pathname) return;
      const hash = fragment ? `#${fragment}` : link.dataset.returnHash || location.hash;
      if (!/^#[\w-]+$/.test(hash)) return;
      if (!fragment) {
        login.searchParams.set("return_to", target + hash);
        link.href = login.pathname + login.search;
      }
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ path: target, hash, at: Date.now() }));
      } catch {}
    },
    true
  );
})();
